import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
  Divider,
  Paper,
} from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import RemoveIcon from '@material-ui/icons/Remove';
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import './EditCart.css';
import ArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import strings from './components/language/language';

const _stringifyObj = (obj) => {
  var myobj = { ...obj };
  let addition_string = [];
  Object.keys(myobj).forEach((key, index) => {
    if (typeof myobj[key] === 'string') {
      addition_string.push(' ' + myobj[key].split('%')[0]);
    } else {
      myobj[key].map((element) => addition_string.push(element.split('%')[0]));
    }
  });
  return addition_string.join(', ');
};
const styles = (theme) => ({
  root: {
    // paddingBottom: '0px',
    // paddingTop: '3px'
  },
  rootIconBtn: {
    fontSize: '16px',
    color: '#fff',
  },
  card: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
    height: 151,
  },
  controls: {
    marginTop: -20,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  deleteIconBtn: {
    // marginLeft:20,
    fontSize: '12px',
    color: 'darkred',
  },
  deleteIcon: {
    fontSize: '22px',
  },
  // Quantity:{
  //    marginLeft: 'auto',
  //    marginRight:'auto',
  //   textAlign: 'center'
  // },
  total: {
    fontSize: '16px',
    verticalAlign: 'center',
    textAlign: 'center',
    color: 'white',
    height: '55px',
    lineHeight: '55px',
  },
  backButton: {
    bottom: 5,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#998d9059',
    },
  },
});

const editcart = (props) => {
  const { classes, theme, promoCode, total, color } = props;
  let itemcount = 0;
  for (let item in props.cartitems) {
    // console.log(item);
    if (props.cartitems[item].price != 0)
      itemcount += props.cartitems[item].count;
  }

  // promo code for order item price
  const promoCodePrice = (price) => {
    const promoCodeDiscountOrder = (price / 100) * promoCode;
    const promoCodeOrder = price - promoCodeDiscountOrder;
    return (
      promoCode && (
        <span style={{ marginLeft: 10 }}>
          {Number.parseFloat(promoCodeOrder.toFixed(2))} {strings.currency}
        </span>
      )
    );
  };

  // promo code for total price
  const promoCodeDiscountTotal = (total / 100) * promoCode;
  const promoCodeTotal = total - promoCodeDiscountTotal;
  return (
    <div style={{ backgroundColor: '#f5f2f2' }}>
      <div id='edit-cart-header' style={{ backgroundColor: color }}>
        {/* <NavLink to="/"><Icon id="back-icon">arrow_back_ios</Icon></NavLink> */}
        <NavLink
          to={props.cartitems.length < 1 ? '/order' : '/checkout'}
          style={{ textDecoration: 'none' }}
        >
          <Button className={classes.backButton}>
            <ArrowLeft /> {strings.back}
          </Button>
        </NavLink>
      </div>
      <div>
        <h1 className='cart-page-title' style={{ color: color }}>
          {strings.your_cart}
        </h1>
      </div>
      <div className='cart-container'>
        <div
          className='cart-list-container'
          style={{
            margin: 'auto',
            width: '50%',
            marginBottom: 50,
          }}
        >
          {props.cartitems.map((item, index) => {
            return item.price == 0 ? null : (
              <div style={{ margin: '20px 15px' }}>
                {/* <Grid item xs={1}> */}

                {/* </Grid> */}
                {/* <Grid item xs={11} style={{ marginTop: 8 }}> */}
                <Card classes={{ root: classes.root }} elevation='0'>
                  <div className={classes.details}>
                    <CardContent
                      classes={{ root: classes.root }}
                      style={{ paddingRight: 0 }}
                    >
                      <Grid container>
                        <Grid item xs={8}>
                          <div className='cart-item-name'>
                            {item.size + ' ' + item.name}
                          </div>
                          <Typography
                            variant='subheading'
                            color='textSecondary'
                          >
                            {_stringifyObj(item.add_ons)}
                          </Typography>
                        </Grid>
                        {/* <Grid item xs={3}>
                 <Typography className="cart-item-price"> {item.price} EGP</Typography>
                 </Grid> */}
                      </Grid>
                      <div
                        style={{
                          color: color,
                          fontWeight: '500px !important',
                          marginTop: 3,
                        }}
                      >
                        <span
                          style={{
                            textDecoration: promoCode ? 'line-through' : 'none',
                          }}
                        >
                          {Number.parseFloat(item.price).toFixed(2)}
                          {strings.currency}
                        </span>
                        {promoCodePrice(item.price)}
                      </div>
                      {/* <Divider /> */}
                      <Grid container className='cart-quantity-container'>
                        {/* <Grid item xs={2}></Grid> */}
                        {/* <Grid item xs={3} className="cart-quantity-title">
                Quantity:
                </Grid> */}
                        <Grid item xs={4} className='cart-quantity-title'>
                          {strings.quantity}:
                        </Grid>
                        <Grid item xs={5} className='cart-controls-container'>
                          <div className='control-icons-container'>
                            <IconButton
                              style={{
                                height: 26,
                                width: 26,
                                backgroundColor: color
                                  ? color
                                  : 'rgba(112,20,45,.575)',
                                borderRadius: 5,
                              }}
                              aria-label='Remove'
                              onClick={() => props.removeItem(index)}
                            >
                              <RemoveIcon
                                classes={{
                                  root: classes.rootIconBtn,
                                }}
                              />
                            </IconButton>
                          </div>
                          <div className='cart-items-quantity'>
                            {item.count}
                          </div>
                          <div className='control-icons-container'>
                            <IconButton
                              style={{
                                height: 26,
                                width: 26,
                                backgroundColor: color
                                  ? color
                                  : 'rgba(112,20,45,.575)',
                                borderRadius: 5,
                              }}
                              aria-label='Add'
                              onClick={() => props.addItem(index)}
                            >
                              <AddIcon
                                classes={{
                                  root: classes.rootIconBtn,
                                }}
                              />
                            </IconButton>
                          </div>
                        </Grid>
                        <Grid item xs={3}>
                          <div className='cart-delete-icon'>
                            <IconButton>
                              <DeleteIcon
                                style={{
                                  color: 'red',
                                  cursor: 'pointer',
                                }}
                                onClick={() => props.deleteItem(index)}
                              />
                            </IconButton>
                          </div>
                        </Grid>

                        {/* <Grid item xs={1}>
                  <div className="cart-items-quantity">
                       {item.count}
                 </div>
                 
                 </Grid> */}
                        {/* <Grid xs={2}> <IconButton aria-label="Add" onClick={()=>props.addItem(index)}>
                  <AddIcon classes={{root: classes.rootIconBtn}} />   
                  </IconButton></Grid>
                  <Grid xs={2}></Grid> */}
                      </Grid>
                    </CardContent>
                    {/* <Divider className="checkout-divider" /> */}

                    {/* <div className={classes.controls}>
                  <IconButton aria-label="Remove" onClick={()=>props.removeItem(index)}>
                  <RemoveIcon />
                  </IconButton>
                  <Typography className={classes.Quantity} variant="subheading" color="textSecondary">
                       Quantity: {item.count}
                 </Typography>
                  <IconButton aria-label="Add" onClick={()=>props.addItem(index)}>
                  <AddIcon />   
                  </IconButton>
                  <IconButton onClick={()=>props.deleteItem(index)} className={classes.deleteIconBtn} aria-label="Remove">
                  <DeleteIcon className={classes.deleteIcon}  />
                  </IconButton>
                </div> */}
                  </div>
                </Card>
                {/* </div> */}
              </div>
            );
          })}
        </div>
      </div>
      {itemcount > 0 ? (
        <NavLink to='/checkout' style={{ textDecoration: 'none' }}>
          <div className='cart-total-price' style={{ backgroundColor: color }}>
            <Typography className={classes.total}>
              {strings.checkout}
              <span
                style={{
                  marginLeft: 10,
                  textDecoration: promoCode ? 'line-through' : 'none',
                }}
              >
                {total}
                {strings.currency}
              </span>
              {promoCode && (
                <span style={{ marginLeft: 10 }}>
                  {promoCodeTotal.toFixed(2)} {strings.currency}
                </span>
              )}
            </Typography>
          </div>
        </NavLink>
      ) : (
        <NavLink to='/order' style={{ textDecoration: 'none' }}>
          <div className='cart-total-price' style={{ background: color }}>
            <Typography className={classes.total}>Back To Order</Typography>
          </div>
        </NavLink>
      )}
    </div>
  );
};
export default withStyles(styles, { withTheme: true })(editcart);



// WEBPACK FOOTER //
// ./src/editcart.js